<template>
    <div data-test-view="reviews-cycles-edit-confirm">
        <l-reviews-edit-cycles-header :id="id" :title="title" />

        <l-reviews-edit-confirm-admin-form
            v-if="reviewCycle.createdAsRole != 'manager' && reviewCycle.createdAsRole != 'employee'"
            :id="id"
        />
        <l-reviews-edit-confirm-manager-form v-else :id="id" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LReviewsEditCyclesHeader from "@/components/LReviewsEditCyclesHeader";
import LReviewsEditConfirmAdminForm from "@/components/LReviewsEditConfirmAdminForm";
import LReviewsEditConfirmManagerForm from "@/components/LReviewsEditConfirmManagerForm";

export default {
    components: {
        LReviewsEditCyclesHeader,
        LReviewsEditConfirmAdminForm,
        LReviewsEditConfirmManagerForm,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            reviewCycle: {},
        };
    },
    computed: {
        ...mapGetters({
            getCycleDetails: "reviews/cycles/details",
        }),

        title() {
            if (["employee", "manager"].includes(this.reviewCycle.createdAsRole)) {
                return this.$t(`reviews.admin.cycleTitle`);
            }

            return this.$t(`reviews.admin.confirmTitle`);
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                this.reviewCycle = this.getCycleDetails(this.id);

                if (this.reviewCycle.status.globalStatus !== "draft") {
                    this.$router.replace(`/reviews/cycles/edit/${this.id}/status`);
                }
            },
        },
    },
};
</script>
